import { Fragment } from "react";

/**
 * A headline's lines as one block of text: each line after the first starts
 * on a break, with a space before it. A block to each line drew the same,
 * but a browser then measured every line on its own, so a paragraph that
 * arrived later (the answer in the home hero's product) counted as the
 * page's largest text and its largest paint came seconds late. The space is
 * for a reader of the HTML that does not lay it out: without it the lines
 * run together ("One business.One Twin.").
 */
export function HeadlineLines({ lines }: { lines: readonly string[] }) {
  return lines.map((line, index) => (
    <Fragment key={line}>
      {index > 0 ? (
        <>
          {" "}
          <br />
        </>
      ) : null}
      {line}
    </Fragment>
  ));
}
